import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import { Button, Typography, CircularProgress } from '@material-ui/core';
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline';
import ErrorOutline from '@material-ui/icons/ErrorOutline';
import { PGService } from '../../Remote/PowerGym';
import { clearReturnState, readReturnedAssertion, startAccountLink } from './asLinkFlow';
import './LinkAccount.css';

/**
 * `/vincular`: vuelta del Auth Service con `#assertion=`. Verifica el `state`, entrega la
 * afirmación al core y muestra el resultado. Si no hay sesión del socio (localStorage.user), manda
 * al login conservando el destino.
 */
class LinkAccountReturn extends Component {
    state = { status: 'working', reason: null, message: null, done: false };

    async componentDidMount() {
        if (!localStorage.getItem('user')) {
            return;
        }
        const { assertion, stateOk } = readReturnedAssertion();
        // Sacar la afirmación de la URL cuanto antes (historial, recargas).
        if (window.history && window.history.replaceState) {
            window.history.replaceState(null, '', window.location.pathname);
        }
        if (!assertion) {
            this.setState({ status: 'error', reason: 'missing' });
            return;
        }
        if (!stateOk) {
            clearReturnState();
            this.setState({ status: 'error', reason: 'state_mismatch' });
            return;
        }
        const res = await PGService.linkAccount(assertion);
        clearReturnState();
        if (res && res.success) {
            this.setState({ status: 'ok' });
            return;
        }
        this.setState({
            status: 'error',
            reason: (res && res.reason) || 'unknown',
            message: (res && res.message) || null,
        });
    }

    retry = async () => {
        this.setState({ status: 'working' });
        const result = await startAccountLink();
        if (!result.ok) {
            this.setState({ status: 'error', reason: 'unknown', message: result.message });
        }
    };

    render() {
        const { t } = this.props;
        const { status, reason, message, done } = this.state;

        if (!localStorage.getItem('user')) {
            return <Redirect to={{ pathname: '/login', state: { from: { pathname: '/' } } }} />;
        }
        if (done) {
            return <Redirect to="/" />;
        }

        return (
            <div className="asLinkGate">
                <section className="asLinkCard">
                    {status === 'working' && (
                        <div className="asLinkLoading">
                            <CircularProgress />
                            <Typography variant="body2">{t('as_link_return_working')}</Typography>
                        </div>
                    )}
                    {status === 'ok' && (
                        <div className="asLinkStatus">
                            <span className="asLinkStatusIcon ok" aria-hidden="true"><CheckCircleOutline /></span>
                            <Typography component="h1" className="asLinkTitle">{t('as_link_return_ok_title')}</Typography>
                            <Typography component="p" className="asLinkLead">{t('as_link_return_ok_body')}</Typography>
                            <Button variant="contained" color="primary" fullWidth size="large" className="asLinkButton" onClick={() => this.setState({ done: true })}>
                                {t('as_link_return_continue')}
                            </Button>
                        </div>
                    )}
                    {status === 'error' && (
                        <div className="asLinkStatus">
                            <span className="asLinkStatusIcon error" aria-hidden="true"><ErrorOutline /></span>
                            <Typography component="h1" className="asLinkTitle">{t('as_link_return_error_title')}</Typography>
                            <Typography component="p" className="asLinkLead">
                                {t(`as_link_return_error_${reason}`, { defaultValue: message || t('as_link_return_error_unknown') })}
                            </Typography>
                            {reason !== 'email_taken' && reason !== 'staff_not_allowed' && (
                                <Button variant="contained" color="primary" fullWidth size="large" className="asLinkButton" onClick={this.retry}>
                                    {t('as_link_return_retry')}
                                </Button>
                            )}
                            <Button fullWidth onClick={() => this.setState({ done: true })} className="asLinkSecondary">
                                {t('as_link_return_home')}
                            </Button>
                        </div>
                    )}
                </section>
            </div>
        );
    }
}

export default connect()(withNamespaces()(LinkAccountReturn));
